import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import shared from './shared';
import loader from '../../methods/loader';
import methodModel from '../../methods/methods';
import { BsArrowBarLeft } from 'react-icons/bs';
import { CgArrowLeft } from 'react-icons/cg';
import PhoneInput from 'react-phone-input-2';
import { LiaEdit } from 'react-icons/lia';

function View() {
    const [data, setData] = useState({});
    const history = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        getDetail();
    }, []);

    const getDetail = () => {
        loader(true);
        ApiClient.get(shared.detailApi, { id }).then((res) => {
            loader(false);
            if (res.success) {
                const { data } = res;
                setData(data);
            }
        });
    };

    const openImage = (image) => {
        if (image) window.open(methodModel.noImg(image), '_blank');
        else return;
    };

    return (
        <Layout>
            <div className="wrapper_section">


                <div className='flex gap-3 justify-between flex-wrap mb-8'>


                    <div className="flex items-center">
                        <Tooltip placement="top" title="Back">
                            <span
                                onClick={() => history(-1)}
                                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3 bg-[#CC9900] text-white hover:text-black"
                            >
                                <CgArrowLeft />


                            </span>
                        </Tooltip>



                        <div>
                            <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                                {shared.addTitle}
                                {' '}
                                Details
                            </h3>
                        </div>
                    </div>



                    {/* <Tooltip placement="top" title="Edit">
            <div className=' bg-primary text-white px-4 py-2 rounded-lg cursor-pointer hover:shadow-lg'>
              <Link to={`/${shared.url}/edit/${id}`} className=" flex items-center gap-2" >
                <LiaEdit />
                <p>Edit</p>
              </Link>

            </div>
          </Tooltip> */}


                </div>




                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12">
                        <div className="  bg-white p-5 rounded-[12px] shadow-[0px_3px_14px_-8px_#888888] border  gap-4 shrink-0 ">
                            <div>
                                <h4 className="text-[#2D2D2D] font-semibold">Basic Information</h4>
                            </div>
                            <div className="grid grid-cols-12 gap-5">
                                <div className="col-span-6 flex flex-col">
                                    <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Title:</label>
                                    <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3">
                                        {data && data?.type}
                                    </p>
                                </div>
                                <div className="col-span-6 flex flex-col">
                                    <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Recipient:</label>
                                    <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3">
                                        {data?.to?.fullName}
                                    </p>
                                </div>




                                <div className="col-span-12 flex flex-col">
                                    <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Description:</label>
                                    <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3">
                                        {data?.discription}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default View;
